import { Box } from "./Box";
import { Event } from "../events/Event";
export class LayoutBox extends Box {
    constructor() {
        super(...arguments);
        this._space = 0;
        this._align = "none";
        this._itemChanged = false;
        this._skipHidden = false;
        this._autoSizeMode = LayoutBox.AUTO_SIZE_NONE;
    }
    get space() {
        return this._space;
    }
    set space(value) {
        this._space = value;
        this._setItemChanged();
    }
    get align() {
        return this._align;
    }
    set align(value) {
        this._align = value;
        this._setItemChanged();
    }
    get skipHidden() {
        return this._skipHidden;
    }
    set skipHidden(value) {
        if (this._skipHidden !== value) {
            this._skipHidden = value;
            this._setItemChanged();
        }
    }
    _setItemChanged() {
        if (!this._itemChanged) {
            this._itemChanged = true;
            this.callLater(this.changeItems);
        }
    }
    changeItems() {
        this._itemChanged = false;
    }
    _calcSizeWithSpace(totalChildSize, count) {
        return count > 0 ? totalChildSize + (count - 1) * this._space : 0;
    }
    onResize(e) {
        this._setItemChanged();
    }
    _childChanged(child) {
        super._childChanged(child);
        if (child) {
            if (child.parent == this)
                child.on(Event.RESIZE, this, this.onResize);
            else
                child.off(Event.RESIZE, this, this.onResize);
            this._setItemChanged();
        }
    }
    refresh() {
        this._setItemChanged();
    }
}
LayoutBox.AUTO_SIZE_NONE = "none";
LayoutBox.AUTO_SIZE_BOTH = "both";
